<form [formGroup]="diseasesInformationForm" id="diseasesInformationForm">
  <!-- Diabetes Diagnosis -->
  <div class="mb-6">
    <label class="form-label fw-bold mb-5">{{
      "haveYouBeenDiagnosedWithDiabetes" | translate
      }}</label>
    <div class="d-flex flex-column gap-3">
      <div *ngFor="let diagnosis of diabetDiagnosisTypes" class="form-check form-check-custom form-check-solid">
        <input class="form-check-input" type="radio" formControlName="hasDiabetes" [value]="diagnosis.value"
          [id]="diagnosis.id" />
        <label class="form-check-label" [for]="diagnosis.id">
          {{ diagnosis.text | translate }}
        </label>
      </div>
    </div>
    <div *ngIf="isControlInvalid('hasDiabetes')" class="text-danger mt-2">
      {{ "selectionRequired" | translate }}
    </div>
  </div>

  <ng-container *ngIf="diseasesInformationForm.value.hasDiabetes">
    <!-- Diyabetes Type -->
    <div class="mb-6">
      <label class="form-label fw-bold mb-5">{{
        "whatIsTheTypeOfDiabetes" | translate
        }}</label>
      <div class="d-flex flex-column gap-3">
        <div *ngFor="let type of diabetesTypes" class="form-check form-check-custom form-check-solid">
          <input class="form-check-input" type="radio" formControlName="diabetesTypeId" [value]="type.id"
            [id]="type.id" />
          <label class="form-check-label" [for]="type.id">
            {{ type.name | translate }}
          </label>
        </div>
      </div>
    </div>

    <!-- When Were You Diagnosed? -->
    <div class="mb-6">
      <div class="row">
        <div class="col-md-3">
          <label class="form-label fw-bold mb-3">
            {{ "whenWereYouDiagnosed" | translate }}
          </label>
          <select formControlName="diagnosisDateView" class="form-select" (change)="onYearSelected($event)">
            <option value="" disabled selected>
              {{ 'date' | translate }}
            </option>
            <option *ngFor="let year of years" [value]="year">{{ year }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Are you taking medications for diabetes? -->
    <div class="mb-6">
      <label class="form-label fw-bold mb-5">{{
        "areYouTakingMedicationsForDiabetes" | translate
        }}</label>
      <div class="d-flex flex-column gap-3">
        <div *ngFor="let item of medicationForDiabetes" class="form-check form-check-custom form-check-solid">
          <input class="form-check-input" type="checkbox" [formControlName]="item.id" [id]="item.id"
            (change)="onDiabetesMedicationChange(item.value)" />
          <label class="form-check-label" [for]="item.id">
            {{ item.text | translate }}
          </label>
        </div>
      </div>
    </div>

    <ng-container *ngIf="!diseasesInformationForm.value.none">
      <!-- Insulin -->
      <ng-container *ngIf="diseasesInformationForm.value.insulin">
        <!-- Insulin Administration Route -->
        <div class="mb-6">
          <label class="form-label fw-bold mb-5">{{
            "insulinAdministrationRoute" | translate
            }}</label>
          <div class="d-flex flex-column gap-3">
            <div *ngFor="let item of insulinAdministrationRouteArr"
              class="form-check form-check-custom form-check-solid">
              <input class="form-check-input" type="radio" [value]="item.id" [id]="item.id"
                formControlName="insulinAdministrationMethod" />
              <label class="form-check-label" [for]="item.id">
                {{ item.text | translate }}
              </label>
            </div>
          </div>
        </div>
        <!-- Insulin Schedule -->
        <div class="mb-6">
          <label class="form-label fw-bold mb-5">{{
            "insulinSchedule" | translate
            }}</label>
          <div class="table-responsive">
            <table class="table table-bordered mb-0">
              <thead>
                <tr>
                  <th *ngFor="let item of insulinTableHeaders">
                    {{ item | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let time of times">
                  <tr>
                    <td>{{ time.id | translate }}</td>
                    <td>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" [formControlName]="time.id + 'InsulinSelected'"
                          id="{{ time.id }}InsulinSelectedYes" [value]="true"
                          (change)="onInsulinSelectionChange(time.id, true)" />
                        <label class="form-check-label" for="{{ time.id }}InsulinSelectedYes">{{ "yes" | translate
                          }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" [formControlName]="time.id + 'InsulinSelected'"
                          id="{{ time.id }}InsulinSelectedNo" [value]="false"
                          (change)="onInsulinSelectionChange(time.id, false)" />
                        <label class="form-check-label" for="{{ time.id }}InsulinSelectedNo">{{ "no" | translate
                          }}</label>
                      </div>
                    </td>

                    <td class="d-flex align-items-center" *ngIf="isInsulinSelected(time.id)">
                      <div *ngFor="let insulinType of insulinTypes" class="form-check form-check-inline">
                        <input class="form-check-input" type="radio"
                          [name]="time.id + 'InsulinType'"
                          [checked]="isInsulinTypeSelected(time.id, insulinType.name)"
                          id="{{ time.id }}{{ insulinType.id }}"
                          (change)="onInsulinTypeChange(time.id, insulinType.name)" />
                        <label class="form-check-label" for="{{ time.id }}{{ insulinType.id }}">{{ insulinType.name
                          }}</label>
                      </div>
                    </td>
                    <td *ngIf="isInsulinSelected(time.id)">
                      <div class="input-group">
                        <input type="number" class="form-control" [formControlName]="time.id + 'InsulinDose'"
                          placeholder="0" />
                        <span class="input-group-text">{{ getDoseUnitByMedicationType(true) }}</span>
                      </div>
                    </td>
                    <td *ngIf="isInsulinSelected(time.id)">
                      <input type="time" class="form-control" [formControlName]="time.id + 'InsulinTime'"
                        placeholder="{{ 'timeInput' | translate }}" />
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>

      <!-- Oral Hypoglycemic -->
      <ng-container *ngIf="diseasesInformationForm.value.oralHypoglycemic">
        <!-- Oral Hypoglycemic Schedule -->
        <div class="mb-6">
          <label class="form-label fw-bold mb-5">{{
            "oralHypoglycemicSchedule" | translate
            }}</label>
          <div class="table-responsive">
            <table class="table table-bordered mb-0 oral-hypoglycemic-table">
              <colgroup>
                <col class="oral-col-time" />
                <col class="oral-col-selected" />
                <col class="oral-col-medicine" />
                <col class="oral-col-dose" />
                <col class="oral-col-time-input" />
              </colgroup>
              <thead>
                <tr>
                  <th *ngFor="let item of oralHypoglycemicTableHeaders">
                    {{ item | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let time of times">
                  <tr>
                    <td>{{ time.id | translate }}</td>
                    <td>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" [formControlName]="
                            time.id + 'OralHypoglycemicSelected'
                          " id="{{ time.id }}SelectedYes" [value]="true"
                          (change)="onOralHypoglycemicSelectionChange(time.id, true)" />
                        <label class="form-check-label" for="{{ time.id }}SelectedYes">{{ "yes" | translate }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" [formControlName]="
                            time.id + 'OralHypoglycemicSelected'
                          " id="{{ time.id }}SelectedNo" [value]="false"
                          (change)="onOralHypoglycemicSelectionChange(time.id, false)" />
                        <label class="form-check-label" for="{{ time.id }}SelectedNo">{{ "no" | translate }}</label>
                      </div>
                    </td>
                    <td>
                      <ng-container *ngIf="isOralHypoglycemicSelected(time.id); else oralMedicinePlaceholder">
                        <div class="d-flex align-items-center">
                          <input class="form-control" [formControlName]="
                              time.id + 'OralHypoglycemicMedicineName'
                            " id="inputFirstName" type="text" [placeholder]="'medicineName' | translate" />
                        </div>
                      </ng-container>
                      <ng-template #oralMedicinePlaceholder>
                        <div class="oral-input-placeholder"></div>
                      </ng-template>
                    </td>
                    <td>
                      <ng-container *ngIf="isOralHypoglycemicSelected(time.id); else oralDosePlaceholder">
                        <div class="input-group">
                          <input type="number" class="form-control" [formControlName]="time.id + 'OralHypoglycemicDose'"
                            placeholder="0" />
                          <span class="input-group-text">{{ getDoseUnitByMedicationType(false) }}</span>
                        </div>
                      </ng-container>
                      <ng-template #oralDosePlaceholder>
                        <div class="oral-input-placeholder"></div>
                      </ng-template>
                    </td>
                    <td>
                      <ng-container *ngIf="isOralHypoglycemicSelected(time.id); else oralTimePlaceholder">
                        <input type="time" class="form-control" [formControlName]="time.id + 'OralHypoglycemicTime'"
                          placeholder="{{ 'timeInput' | translate }}" />
                      </ng-container>
                      <ng-template #oralTimePlaceholder>
                        <div class="oral-input-placeholder"></div>
                      </ng-template>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <!-- Lab Informations -->
  <div class="mb-6">
    <label class="form-label fw-bold mb-5">{{
      "labInformations" | translate
      }}</label>
    <div class="table-responsive">
      <table class="table table-bordered mb-0">
        <thead>
          <tr>
            <th>{{ "testDate" | translate }}</th>
            <th>
              {{ "timeOfDay" | translate }}
            </th>
            <th>{{ "hbA1cValue" | translate }}</th>
            <th>{{ "targetLowerLimit" | translate }}</th>
            <th>{{ "targetUpperLimit" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <input formControlName="testDate" type="text" class="form-control" id="inputTestDate"
                (ngModelChange)="onDateInputChange($event, 'testDate')" placeholder="{{ 'date' | translate }}"
                [max]="maxDate" maxlength="10" />
            </td>

            <td>
              <input type="time" class="form-control" formControlName="timeOfDay"
                placeholder="{{ 'timeInput' | translate }}" />
            </td>
            <td>
              <input type="number" class="form-control" formControlName="hbA1cValue" placeholder="0" [min]="0"
                [max]="100" (input)="preventForbiddenCharacters($event, 'number')" />
            </td>
            <td>
              <input type="number" class="form-control" formControlName="targetLowerLimit" placeholder="0" [min]="0"
                [max]="100" (input)="preventForbiddenCharacters($event, 'number')" />
            </td>
            <td>
              <input type="number" class="form-control" formControlName="targetUpperLimit" placeholder="0" [min]="0"
                [max]="100" (input)="preventForbiddenCharacters($event, 'number')" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Other Important Chronic Diseases -->
  <div class="mb-6">
    <label class="form-label fw-bold mb-5">{{
      "otherImportantChronicDiseases.title" | translate
      }}</label>
    <div class="d-flex flex-column gap-3">
      <ng-container *ngFor="let disease of chronicDiseases">
        <div class="form-check form-check-custom form-check-solid">
          <input class="form-check-input" type="checkbox" [formControlName]="disease" [id]="disease" />
          <label class="form-check-label" [for]="disease">
            {{ "otherImportantChronicDiseases." + disease | translate }}
          </label>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Other Medications -->
  <div class="mb-6">
    <label class="form-label fw-bold mb-5">{{
      "otherMedications" | translate
      }}</label>
    <div class="table-responsive">
      <table class="table table-bordered mb-0">
        <thead>
          <tr>
            <th>{{ "timeOfDay" | translate }}</th>
            <th>
              {{ "medicineName" | translate }}
            </th>
            <th>{{ "dose" | translate }}</th>
            <th>{{ "time" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let time of times">
            <tr>
              <td>{{ time.id | translate }}</td>
              <td>


                <!-- Show select if certain medication selected -->
                <ng-template #selectMedication>
                  <select class="form-select" [formControlName]="'otherMed_' + time.id + 'Name'"
                    id="otherMed_{{ time.id }}Name">
                    <option value="null">
                      {{ "selectMedication" | translate }}
                    </option>
                    <option *ngFor="let med of medicationList" [value]="med.id">
                      {{ med.name | translate }}
                    </option>
                  </select>
                </ng-template>
                <!-- Show text area if others selected -->
                <ng-container *ngIf="
                    diseasesInformationForm.get('otherMed_' + time.id + 'Name')
                      ?.value === otherMedicationId;
                    else selectMedication
                  ">
                  <div>
                    <select class="form-select" [formControlName]="'otherMed_' + time.id + 'Name'"
                      id="otherMed_{{ time.id }}Name">
                      <option value="null">
                        {{ "selectMedication" | translate }}
                      </option>
                      <option *ngFor="let med of medicationList" [value]="med.id">
                        {{ med.name | translate }}
                      </option>
                    </select>
                    <input type="text" class="form-control" [formControlName]="
                        'otherMed_' + time.id + 'OtherMedication'
                      " placeholder="{{ 'other' | translate }}" />
                  </div>
                </ng-container>
              </td>
              <td>
                <input type="number" class="form-control" [formControlName]="'otherMed_' + time.id + 'Dose'"
                  placeholder="0" [min]="0" [max]="999" (input)="preventForbiddenCharacters($event, 'number')" />
              </td>
              <td>
                <input type="time" class="form-control" [formControlName]="'otherMed_' + time.id + 'Time'"
                  placeholder="{{ 'timeInput' | translate }}" />
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Save Button -->
  <!-- <div class="text-end mt-5">
    <button (click)="savePreparation($event)" type="submit" class="btn btn-sm btn-primary cursor-pointer">
      {{ "save" | translate }}
    </button>
  </div> -->
  <!-- Next Step Button -->
  <div class="text-end">
    <button
      (click)="goToNextStep()"
      type="submit"
      class="btn btn-sm btn-primary cursor-pointer"
    >
      {{ "nextStep" | translate }}
    </button>
  </div>
</form>
